<template>
	<div class="home-box">
		<div class="flex">
			<div class="flex3">
				<p class="title-box">
					<span class="title">公告栏</span>
					<span class="more" @click="handleNotice">
						更多
						<i class="el-icon-arrow-right"></i>
					</span>
				</p>
				<el-carousel height="200px">
					<el-carousel-item v-for="(item, i) in noticeList" :key="i">
						<div class="notice-box" @click="handleNoticeDetail(item.id)">
							<img class="notice-bg" src="@/assets/images/banner.png" alt="" />
							<p class="notice-title" style="-webkit-box-orient: vertical">{{ item.subject }}</p>
							<div class="notice-content" v-html="item.content"></div>
						</div>
					</el-carousel-item>
				</el-carousel>
				<div class="title-box mb0">
					<span class="title look-more">了解更多</span>
					<div class="flex">
						<div class="liaojie-more">
							<img src="@/assets/images/home_bbs.png" alt="" />
							<div class="btn-box">
								<p>技术论坛</p>
								<div class="claim">
									<button @click="handleBBS">查看更多</button>
								</div>
							</div>
						</div>
						<div class="liaojie-more">
							<img src="@/assets/images/skills.png" alt="" />
							<div class="btn-box">
								<p>技能评价</p>
								<div class="claim">
									<button @click="handleSkills">查看更多</button>
								</div>
							</div>
						</div>
					</div>
					<div class="flex">
						<div class="liaojie-more">
							<img src="@/assets/images/video.png" alt="" />
							<div class="btn-box">
								<p>视频分享</p>
								<div class="video">
									<button @click="handleVideo">查看更多</button>
								</div>
							</div>
						</div>
						<div class="liaojie-more">
							<img src="@/assets/images/technique.png" alt="" />
							<div class="btn-box">
								<p>技术资料</p>
								<div class="technique">
									<button @click="handleTechnical">查看更多</button>
								</div>
							</div>
						</div>
					</div>
					<div class="flex">
						<div class="liaojie-more">
							<img src="@/assets/images/claimant.png" alt="" />
							<div class="btn-box">
								<p>索赔管理</p>
								<div class="claim">
									<button @click="handleClaimant">查看更多</button>
								</div>
							</div>
						</div>
						<div class="liaojie-more">
							<img src="@/assets/images/parts.png" alt="" />
							<div class="btn-box">
								<p>零件查询</p>
								<div class="part">
									<button @click="handleParts">点击查看</button>
								</div>
							</div>
						</div>
					</div>
					<div class="flex">
						<div class="liaojie-more">
							<img src="@/assets/images/xiazai.png" alt="" />
							<div class="btn-box">
								<p>固件下载</p>
								<div class="gujian">
									<button @click="handleDownload">点击查看</button>
								</div>
							</div>
						</div>
						<div class="liaojie-more">
							<img src="@/assets/images/FAQ.png" alt="" />
							<div class="btn-box">
								<p>全球FAQ</p>
								<div class="quanqiu">
									<button class="left" @click="handleFAQ('zh')">中文版</button>
									<button class="right" @click="handleFAQ('en')">英文版</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="flex2">
				<p class="title-box item-center">
					<span class="title">我的通信箱</span>
					<span class="more" @click="handleMailbox('')">
						更多
						<i class="el-icon-arrow-right"></i>
					</span>
				</p>
				<ul class="email-box">
					<li v-for="(item, i) in mailBoxList" :class="'li-border-color' + i" :key="i" @click="handleMailbox(item)">
						<p :class="item.readFlag == 0 ? 'fwb' : ''">{{ item.title }}</p>
						<p>
							<img src="@/assets/images/shijian.png" alt="" />
							{{ $moment(item.createTimeStr).format("YYYY-MM-DD HH:mm:ss") }}
						</p>
					</li>
				</ul>

				<p class="title-box item-center mt-20">
					<span class="title">我的课程</span>
					<span class="more" @click="handleCourse">
						更多
						<i class="el-icon-arrow-right"></i>
					</span>
				</p>
				<ul class="email-box">
					<li v-for="(item, i) in courseList" :class="'li-border-color' + i" :key="i">
						<div class="course-item-content" @click="handleExam(item)">
							<div class="course-item-info">
								<p :class="item.courseName ? 'fwb' : ''">{{ item.courseName }}</p>
								<p>
									{{ item.startTime }} - {{ item.endTime }}
								</p>
							</div>
							<button class="submit"  @click.stop="handleExam(item)">开始考试</button>
						</div>
					</li>
				</ul>
				<img v-if="courseList.length == 0" style="width: 100%; border-radius: 6px;" src="@/assets/images/zanwukecheng.png" alt="" />
			</div>
		</div>

		<div class="flex1">
			<div>
				<img src="@/assets/images/liguangzhongguo.png" alt="" />
				<p>理光(中国)微信号</p>
			</div>
			<div>
				<img src="@/assets/images/liguangfuwu.png" alt="" />
				<p>理光服务微信号</p>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			// 权限
			perms: JSON.parse(window.sessionStorage.getItem("perms")),
			mailBoxList: [],
			noticeList: [],
			courseList: [],
		};
	},
	mounted() {
		this.getHomeList();
		this.getOnlineList();
	},
	methods: {
		// FAQ
		handleFAQ(type) {
			this.$message.error("此功能关闭，将在不久后根据要求设置后重新开放，内部人员请使用SYNK");
			// // 中文版
			// if (type == "zh") {
			// 	let that = this;
			// 	that.$request.post("getFaqUrl", false, {}, function (r) {
			// 		window.open("https://cn-tier2-sc.custhelp.com/ci/pta/login/redirect/app/answers/list/p_li/" + JSON.parse(r.data).fqa_url);
			// 	});
			// }
			// // 英文版
			// else {
			// 	let that = this;
			// 	that.$request.post("getFaqUrl", false, {}, function (r) {
			// 		window.open("https://cn-tier2-en.custhelp.com/ci/pta/login/redirect/app/answers/list/p_li/" + JSON.parse(r.data).fqa_url);
			// 	});
			// }
		},
		// 固件下载
		handleDownload() {
			if (!this.perms.includes("home:download")) {
				this.$message.error("您的账号没有固件下载权限，如需固件请通过通信箱向渠道支援申请或者查询已存固件");
				return;
			}
			this.$alert(
				"本网站提供的技术资料，属于理光（中国）非公开的技术信息资料等，仅供理光认证工程师维修理光产品使用，非经理光（中国）许可，不得以任何形式、通过任何途径进行复制、发行或传播。",
				"",
				{
					confirmButtonText: "确定",
					callback: (action) => {
						let that = this;
						that.$request.post("clickFirmware", false, {}, function (r) {
							that.$request.post(
								"getInfoByCode",
								false,
								{
									code: "firmwareDownload",
								},
								function (r) {
									window.open(
										"https://" +
											encodeURIComponent(JSON.parse(r.data.val).user) +
											":" +
											encodeURIComponent(JSON.parse(r.data.val).pwd) +
											"@support.ricoh.com/bbv22/html/firm_e/index_staff_e.html",
									);
								},
							);
						});
					},
				},
			);
		},
		// 视频分享
		handleVideo() {
			this.$router.push({
				name: "video",
			});
		},
		// 索赔管理
		handleClaimant() {
			if (!this.perms.includes("home:repair")) {
				this.$message.error("此功能仅供拥有索赔权限人员使用");
				return;
			}
			this.$router.push({
				name: "claimantManagement",
			});
		},
		// 技术资料
		handleTechnical() {
			this.$router.push({
				name: "technique",
			});
		},
		getHomeList() {
			let that = this;
			that.$request.post("getHomeList", true, {}, function (r) {
				if (r.code == "0") {
					that.noticeList = r.data.noticeList.list;
					that.mailBoxList = r.data.dataSubjectList.list;
				} else {
					that.$message.error(r.msg);
				}
				that.loading = false;
			});
		},
		// 通信箱
		handleNotice() {
			this.$router.push({
				name: "bulletin",
			});
		},
		handleNoticeDetail(id) {
			this.$router.push({
				name: "bulletinDetail",
				query: {
					id: id,
				},
			});
		},
		// 跳转通信箱
		handleMailbox(dt) {
			if (dt) {
				if (dt.status == 0) {
					this.$router.push({
						name: "mailboxAddEdit",
						query: {
							id: dt.id,
						},
					});
				} else {
					this.$router.push({
						name: "mailboxDetail",
						query: {
							id: dt.id,
						},
					});
				}
			} else {
				this.$router.push({
					name: "mailbox",
				});
			}
		},
		// 获取列表数据
		getOnlineList() {
			let that = this;
			that.$request.post(
				"getExamCourseList",
				true,
				{
					pageNo: 1,
					pageSize: 3,
				},
				function (r) {
					if (r.code == "0") {
						that.courseList = r.data.list;
					} else {
						that.$message.error(r.msg);
					}
				},
			);
		},
		// 在线考试
		handleCourse() {
			this.$router.push({
				name: "onlineExam",
			});
		},
		// 考试
		handleExam(dt) {
			this.$router.push({
				name: "examLearn",
				query: {
					courseId: dt.courseId,
					id: dt.id,
				},
			});
		},
		// BBS
		handleBBS() {
			if (!this.perms.includes("home:bbs")) {
				this.$message.error("此功能仅供拥有BBS权限人员使用");
				return;
			}
			this.$router.push({
				name: "bbs",
			});
		},
		// 零件查询
		handleParts() {
			if (!this.perms.includes("home:parts")) {
				this.$message.error("此功能仅供拥有零件查询权限人员使用");
				return;
			}
			this.$router.push({
				name: "parts",
			});
		},
		// 技能评价
		handleSkills() {
			// 优先检查技能概览权限
			if (this.perms.includes("train:skill") && this.perms.includes("train:skill:view")) {
				this.$router.push({
					name: "skillView",
				});
			}
			// 其次检查技能查看权限
			else if (this.perms.includes("train:skill") && this.perms.includes("train:skill:viewPrivate")) {
				this.$router.push({
					name: "skillViewPrivate",
				});
			}
			// 两个权限都没有，显示错误提示
			else {
				this.$message.error("此功能仅供拥有技能评价权限人员使用");
				return;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.nowrap {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.look-more {
	margin: 20px 0 15px;
	display: inline-block;
}
.my-class {
	box-sizing: border-box;
	padding: 20px;
}
.home-box {
	box-sizing: border-box;
	padding-top: 20px;
}
.mt-20 {
	margin-top: 20px;
}
.flex {
	display: flex;
	.flex2 {
		flex: 2;
		box-sizing: border-box;
		padding-left: 20px;
		display: flex;
		flex-direction: column;
	}
	.flex3 {
		flex: 3;
		box-sizing: border-box;
		padding: 20px;
		background-color: #fff;
		border-radius: 6px;
		img {
			width: 100%;
		}
	}
	.flex4 {
		flex: 6;
		background-color: #fff;
		border-radius: 6px;
	}
}

.flex1 {
	background-color: #fff;
	text-align: center;
	box-sizing: border-box;
	padding: 12px;
	border-radius: 6px;
	position: fixed;
	top: 80px;
	left: 10px;
	z-index: 100;
	width: 140px;
	display: flex;
	flex-direction: column;
	gap: 20px;

	div {
		img {
			width: 120px;
			height: 120px;
			object-fit: contain;
		}
		p {
			font-size: 12px;
			margin-top: 8px;
			white-space: nowrap;
		}
	}
}
.title-box {
	margin-bottom: 15px;

	&.mb0 {
		margin-bottom: 0 !important;

		.flex {
			margin-bottom: 10px;
			&:last-child {
				margin-bottom: 0;
			}
		}
	}
	.title {
		font-size: 22px;
		font-weight: bold;
		color: #333539;
	}
	.more {
		color: #117ffc;
		cursor: pointer;
		float: right;
		margin-right: 10px;
		font-size: 14px;
	}
}
.liaojie-more {
	flex: 1;
	box-sizing: border-box;
	// padding-right: 10px;
	position: relative;
	//height: 187px;
	//padding-top: 6px;
	&:nth-child(even) {
		padding-right: 0;
	}
	&:nth-child(odd) {
		padding-right: 10px;
	}
	&.claimant-section {
		width: 50%;
		padding-right: 5px;

		img {
			max-width: 417px;
		}
	}
	&.bbs-section {
		margin-bottom: 2px;
		padding-right: 0;
		box-sizing: border-box; /* 包含 padding 在宽度内 */

		img {
			width: 842px;
			height: 161px;
			border-radius: 5px;
			display: block; /* 去除底部空白 */
		}
	}

	img {
		width: 100%;
		border-radius: 5px;
	}
	.btn-box {
		position: absolute;
		top: 50%;
		left: 44px;
		transform: translateY(-50%);
		p {
			font-size: 19px;
			font-weight: bold;
			color: #333539;
		}
		.quanqiu {
			margin-top: 20px;
			background-color: #fff;
			.left {
				color: #fff;
				background-color: rgba(246, 111, 62, 1);
				border-radius: 4px 0px 0px 4px;
				border: none;
				outline: none;
				cursor: pointer;
				padding: 6px 10px;
				margin-right: 2px;
			}
			.right {
				color: #fff;
				background-color: rgba(246, 111, 62, 1);
				border-radius: 0px 4px 4px 0px;
				border: none;
				outline: none;
				cursor: pointer;
				padding: 6px 10px;
			}
		}
		.gujian {
			margin-top: 20px;
			button {
				color: #fff;
				background-color: rgba(83, 187, 154, 1);
				border-radius: 4px;
				border: none;
				outline: none;
				cursor: pointer;
				padding: 6px 18px;
			}
		}
		.video {
			margin-top: 20px;
			button {
				color: #fff;
				background-color: rgba(46, 104, 166, 1);
				border-radius: 4px;
				border: none;
				outline: none;
				cursor: pointer;
				padding: 6px 18px;
			}
		}
		.technique {
			margin-top: 20px;
			button {
				color: #fff;
				background-color: rgba(243, 126, 86, 1);
				border-radius: 4px;
				border: none;
				outline: none;
				cursor: pointer;
				padding: 6px 18px;
			}
		}
		.part {
			margin-top: 20px;
			button {
				color: #fff;
				background-color: #c76b8a;
				border-radius: 4px;
				border: none;
				outline: none;
				cursor: pointer;
				padding: 6px 18px;
			}
		}
		.claim {
			margin-top: 20px;
			button {
				color: #fff;
				background-color: #7363f1;
				border-radius: 4px;
				border: none;
				outline: none;
				cursor: pointer;
				padding: 6px 18px;
			}
		}
		.bbs {
			margin-top: 20px;
			button {
				color: #fff;
				background-color: #5198e4;
				border-radius: 4px;
				border: none;
				outline: none;
				cursor: pointer;
				padding: 6px 18px;
			}
		}
	}
}
.notice-box {
	width: 100%;
	position: relative;
	cursor: pointer;
	.notice-title {
		-webkit-box-orient: vertical;
		width: 50%;
		height: 66px;
		line-height: 22px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		position: absolute;
		top: 20px;
		left: 20px;
	}
	.notice-content {
		position: absolute;
		top: 86px;
		left: 60px;
		width: 50%;
		font-size: 14px;
		color: #333333;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 3;
		line-height: 19px;
		max-height: 57px;
	}
}
.email-box {
	li {
		list-style: none;
		// height: 88px;
		height: 89px;
		border-radius: 6px;
		margin-bottom: 10px;
		font-size: 13px;
		box-sizing: border-box;
		padding-top: 20px;
		padding-left: 40px;
		background-color: #fff;
		cursor: pointer;
		img {
			width: 14px;
			height: 14px;
			vertical-align: -2px;
		}
		&:last-child {
			margin-bottom: 0;
		}
		.course-item-content {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 100%;
			.course-item-info {
				flex: 1;
				p:first-child {
					color: rgba(68, 68, 68, 1);
					font-size: 14px;
					margin-bottom: 10px;
					box-sizing: border-box;
					padding-right: 15px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
				p:last-child {
					color: rgba(102, 102, 102, 1);
				}
			}
			.submit{
				display: block;
				width: 78px;
				height: 26px;
				background: #117FFC;
				border-radius: 3px;
				color: #fff;
				border: none;
				outline: none;
				cursor: pointer;
				margin: 0 10px 16px auto;
			}
		}
		p:first-child {
			color: rgba(68, 68, 68, 1);
			font-size: 14px;
			margin-bottom: 10px;
			box-sizing: border-box;
			padding-right: 15px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
		p:last-child {
			color: rgba(102, 102, 102, 1);
		}
		&:hover {
			box-shadow: 0px 9px 19px 2px rgba(207, 207, 207, 0.33);
		}
	}
	.li-border-color0 {
		border-left: 5px solid rgba(102, 114, 251, 1);
		background-color: rgba(239, 241, 255, 1);
	}
	.li-border-color1 {
		border-left: 5px solid rgba(31, 153, 142, 1);
		background-color: rgba(238, 252, 250, 1);
	}
	.li-border-color2 {
		border-left: 5px solid rgba(0, 103, 255, 1);
		background-color: rgba(234, 242, 254, 1);
	}
	.li-border-color3 {
		border-left: 5px solid rgba(232, 82, 63, 1);
		background-color: rgba(254, 246, 245, 1);
	}
	.li-border-color4 {
		border-left: 5px solid rgba(248, 184, 73, 1);
		background-color: rgba(255, 251, 246, 1);
	}
	.li-border-color5 {
		border-left: 5px solid rgb(132, 192, 152);
		background-color: rgba(238, 252, 250, 1);
	}
}

.bbs-box {
	box-sizing: border-box;
	position: relative;
	width: 100%;
	height: 161px;
	text-align: left;
	//line-height: 50px;
	display: inline-block;
	border: none;
	//background-color: rgba(17, 127, 252, 0.2);
	//background: linear-gradient(to right, rgba(17, 127, 252, 0.2), #90baec);
	border-radius: 4px;
	//color: #117FFC;
	font-size: 20px;
	font-weight: bold;
	cursor: pointer;
	margin-right: 10px;
	margin-top: auto;
	letter-spacing: 0.08em;

	img {
		min-width: 100%;
		height: 100%;
		border-radius: 6px;
		background-size: cover;
		background-repeat: no-repeat;
	}

	.btn-box {
		position: absolute;
		top: 50%;
		left: 44px;
		transform: translateY(-50%);
		p {
			font-size: 22px;
			font-weight: bold;
			color: #333539;
		}

		.video {
			margin-top: 20px;
			button {
				color: #fff;
				background-color: #317f9d;
				border-radius: 4px;
				border: none;
				outline: none;
				cursor: pointer;
				padding: 6px 18px;
			}
		}
	}
}

.course-table {
	width: 100%;
	border-collapse: separate;
	border-spacing: 0px 10px;
	thead {
		tr {
			border-radius: 0px 0px 4px 4px;
			th {
				height: 36px;
				font-size: 15px;
				color: #444444;
			}
		}
	}
	tbody {
		tr {
			height: 70px;
			cursor: pointer;
			td {
				img {
					vertical-align: middle;
				}
			}
			.nowrap1 {
				width: 90%;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
		tr:last-child {
			border-radius: 0px 0px 4px 4px;
		}
	}
	.th-bgc {
		background-color: rgba(245, 249, 255, 0.7);
		color: rgba(68, 68, 68, 1);
	}
	.tr-bgc {
		background-color: rgba(245, 249, 255, 1);
		color: rgba(102, 102, 102, 1);
	}
}

.home-bbs-box {
	position: relative;
	margin-bottom: 20px;
	img {
		width: 100%;
		border-radius: 5px;
	}
	.btn-box {
		position: absolute;
		top: 50%;
		left: 44px;
		transform: translateY(-50%);
		p {
			font-size: 19px;
			font-weight: bold;
			color: #333539;
		}
		button {
			color: #fff;
			background-color: #5198e4;
			border-radius: 4px;
			border: none;
			outline: none;
			cursor: pointer;
			padding: 6px 18px;
			margin-top: 20px;
		}
	}
}
.item-center {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.home-bbs-title {
	font-size: 22px;
	font-weight: bold;
	color: #333539;
	margin-bottom: 15px;
}
</style>
